var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "_component-avatar-uploader" }, [
    _c(
      "div",
      { staticClass: "_component-container" },
      [
        _c("input", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.disabled && _vm.state !== _vm.STATE.LOAD,
              expression: "!disabled && state !== STATE.LOAD"
            }
          ],
          ref: "file",
          staticClass: "_uploader-wrap",
          attrs: { type: "file", accept: _vm.acceptTypeStr },
          on: { change: _vm.handleFileChange }
        }),
        _vm.value && _vm.value.url
          ? _c("component-image", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.state === _vm.STATE.SUCCESS,
                  expression: "state === STATE.SUCCESS"
                }
              ],
              attrs: {
                className: "lazy-loader",
                bgSize: "cover",
                type: "bg",
                src: _vm.previewUrl
              }
            })
          : _vm._e(),
        _c("div", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.state === _vm.STATE.READY,
              expression: "state === STATE.READY"
            }
          ],
          staticClass: "_uploader-content ready"
        }),
        _c("div", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.state === _vm.STATE.LOAD,
              expression: "state === STATE.LOAD"
            }
          ],
          staticClass: "_uploader-content load"
        }),
        _c("div", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.state === _vm.STATE.ERROR,
              expression: "state === STATE.ERROR"
            }
          ],
          staticClass: "_uploader-content error"
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }